import { MainNavSiteLogo } from './siteLogo';
import { MainNavSearchBar } from './searchBar';
import { MainNavStreamingNotice } from './streamingNotice';
import { MainNavRefreshBnetButton } from './buttons';
import { FC } from 'react';

type TLargeAuthBarLayoutProps = {
  logoPath: string;
  logoWidth: number;
  logoHeight: number;
  streamingNoticeClickUrl?: string;
  additionalColumnsComponent?: any;
};

export const LargeAuthBarLayout: FC<TLargeAuthBarLayoutProps> = (props) => {
  return (
    <div className="slds-grid slds-grid--align-spread slds-grid--vertical-align-center">
      <div className="slds-col">
        <MainNavSiteLogo logoPath={props.logoPath} width={props.logoWidth} height={props.logoHeight} />
      </div>
      <div className="slds-col">
        <MainNavSearchBar />
      </div>
      <div className="slds-col">
        <div className="slds-grid slds-grid--align-end slds-grid--vertical-align-center rio-auth-nav">
          <MainNavRefreshBnetButton className="slds-col slds-m-right--large rio-hidden--medium rio-hidden--large" />

          <MainNavStreamingNotice className="slds-col slds-p-right--medium" searchUrl={props.streamingNoticeClickUrl} />

          {props.additionalColumnsComponent && <props.additionalColumnsComponent />}
        </div>
      </div>
    </div>
  );
};
